"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACILITY_MAPPING = {
    fetchFacilityDetails: {
        path: '/fetchFacilitiesDetails',
    },
    importFacilityDetails: {
        path: '/importFacilityDetails',
        parameter: '/:chainId'
    },
    addFacility: {
        path: '/addFacility'
    },
    deleteFacility: {
        path: '/deleteFacility',
        parameter: '/:facilityId'
    },
    getFacilities: {
        path: '/getFacilities',
    },
    getFacility: {
        parameter: '/:id',
        path: '/getFacility',
    },
    list: {
        path: '/list',
    },
    updateFacility: {
        parameter: '/:id',
        path: '/updateFacility',
    },
    getFacilityPayerTypes: {
        path: '/getFacilityPayerTypes',
        parameter: '/:facilityId'
    },
    updatePayerTypes: {
        path: '/updatePayerTypes',
        parameter: '/:facilityId'
    },
    changeLogo: {
        path: '/changeLogo',
        parameter: '/:facilityId'
    },
    getFacilitiesTransactionReports: {
        path: '/getFacilitiesTransactionReports',
    },
    getFacilitiesActivePayerTypesMap: {
        path: '/getFacilitiesActivePayerTypesMap'
    },
    getAllPayerTypesMap: {
        path: '/getAllPayerTypesMap'
    },
    fetchFacilityUpdatesFromPcc: {
        path: '/fetchFacilityUpdatesFromPcc',
        parameter: '/:facilityId'
    },
    updateFacilityFromPcc: {
        path: '/updateFacilityFromPcc',
        parameter: '/:chainId'
    },
    hippaAgreementTemplate: {
        path: '/Hipaa%20BAA%20Agreement'
        // path: '/hippaAgreementTemplate'
    },
    zuntaLicenseTemplate: {
        // path: '/zuntaLicenseTemplate'
        path: '/Zunta%20EULA'
    },
    updateFacilityCollectionSettings: {
        path: '/updateFacilityCollectionSettings',
        parameter: '/:facilityId'
    },
    getFacilityCollectionSettings: {
        path: '/getFacilityCollectionSettings',
        parameter: '/:facilityId'
    },
    setupPayerTypes: {
        path: '/setupPayerTypes'
    },
    getPaymentAccount: {
        path: '/getPaymentAccount',
        parameter: '/:facilityId'
    },
    savePaymentAccount: {
        path: '/savePaymentAccount'
    },
    getAutoApplySettings: {
        path: '/getAutoApplySettings',
        parameter: '/:facilityId'
    },
    saveAutoApplySettings: {
        path: '/saveAutoApplySettings'
    },
    importSelectedFacilitiesData: {
        path: '/importSelectedFacilitiesData'
    },
    setupFacilityStatementSettings: {
        path: '/setupFacilityStatementSettings'
    },
    changePayerTypeStatus: {
        path: '/changePayerTypeStatus',
        parameter: '/:payerTypeId'
    },
    prefix: 'facilities',
};
